import axios from 'axios';

const POLL_INTERVAL_MS = 2000;
const MAX_WAIT_MS = 120000;

/**
 * POST /stories/:id/polish returns 202 + job_id; worker writes polished_transcript when done.
 * Poll GET /stories/:id until polished text is available or timeout.
 */
export async function polishStoryAndWait(API, storyId, options = {}) {
  const { onQueued, onPoll } = options;

  const { data: before } = await axios.get(`${API}/stories/${storyId}`);
  const baselineUpdatedAt = before.updated_at;
  const previousPolished = (before.polished_transcript || '').trim();

  const postResp = await axios.post(`${API}/stories/${storyId}/polish`);

  if (postResp.status === 200 && postResp.data?.polished_transcript != null) {
    return String(postResp.data.polished_transcript);
  }

  if (postResp.status !== 202) {
    const detail = postResp.data?.detail;
    throw new Error(
      typeof detail === 'string' ? detail : 'Polish request failed'
    );
  }

  if (typeof onQueued === 'function') {
    onQueued(postResp.data);
  }

  const deadline = Date.now() + MAX_WAIT_MS;

  while (Date.now() < deadline) {
    await new Promise((r) => setTimeout(r, POLL_INTERVAL_MS));
    if (typeof onPoll === 'function') {
      onPoll();
    }

    const { data: cur } = await axios.get(`${API}/stories/${storyId}`);
    const polished = (cur.polished_transcript ?? '').trim();

    if (!polished) continue;

    if (polished !== previousPolished) {
      return polished;
    }
    if (cur.updated_at !== baselineUpdatedAt) {
      return polished;
    }
  }

  throw new Error(
    'Polish timed out. Ensure Redis is running, the ARQ worker is started, and OPENAI_API_KEY is set in backend/.env.'
  );
}
